const prefix = "toast/";

export const SHOW = `${prefix}SHOW_ALERT`;
export const HIDE = `${prefix}HIDE_ALERT`;
